import { useEffect, useMemo, useState } from 'react';
import { useProjectBaselineQuery } from 'queries/project-baseline-mutation';
export const useProjectBaselineByProjectId = (projectId)=>{
    const { data, isFetching } = useProjectBaselineQuery(projectId);
    return useMemo(()=>{
        return {
            data: data !== null && data !== void 0 ? data : [],
            isLoading: isFetching
        };
    }, [
        data,
        isFetching
    ]);
};
export const useActiveBaselinesByProjectId = (projectId)=>{
    const { data: baselines } = useProjectBaselineByProjectId(projectId);
    const [activeBaselines, setActiveBaselines] = useState([]);
    useEffect(()=>{
        setActiveBaselines(baselines.filter((_baseline)=>_baseline.deleted !== true));
    }, [
        baselines
    ]);
    return activeBaselines;
};
